import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body border-top p-9" }
const _hoisted_2 = { class: "row mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label required fw-bold fs-6" }, " Tên kho: ", -1)
const _hoisted_4 = { class: "col-lg-8 fv-row" }
const _hoisted_5 = { class: "fv-plugins-message-container" }
const _hoisted_6 = { class: "fv-help-block" }
const _hoisted_7 = { role: "alert" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label required fw-bold fs-6" }, " Mã kho: ", -1)
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = { class: "row mt-5 mb-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fw-bold fs-6" }, " Ghi chú kho ", -1)
const _hoisted_13 = { class: "col-lg-8 fv-row" }
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label required fw-bold fs-6" }, " Địa chỉ ", -1)
const _hoisted_16 = { class: "col-lg-8 fv-row" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { role: "alert" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fw-bold fs-6" }, " Đơn vị ", -1)
const _hoisted_22 = { class: "col-lg-8 fv-row" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "card-footer d-flex justify-content-end py-6 px-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_TaiKhoanSelection = _resolveComponent("TaiKhoanSelection")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!

  return (_openBlock(), _createBlock(_component_PageRowLayout, null, {
    "page-row-header": _withCtx(() => [
      _createTextVNode(" Cập nhật ")
    ]),
    "page-row-action-button": _withCtx(() => [
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.BACK,
        onClick: _ctx.goBack
      }, null, 8, ["button-type", "onClick"])
    ]),
    "page-row-content": _withCtx(() => [
      _createElementVNode("form", {
        class: "form",
        onKeypress: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["enter"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                type: "text",
                name: "name",
                ref: "firstInput",
                class: "form-control form-control-lg form-control-solid",
                placeholder: "Tên kho"
              }, null, 512), [
                [_vModelText, _ctx.name]
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.nameErrorMess), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "code",
                disabled: "",
                readonly: "",
                class: "form-control form-control-lg",
                placeholder: "Mã kho",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.code) = $event))
              }, null, 512), [
                [_vModelText, _ctx.code]
              ])
            ])
          ]),
          _createVNode(_component_TaiKhoanSelection, {
            labelCols: 2,
            inputsCols: 4,
            "ma-tai-khoan-prop": _ctx.taiKhoanData.maTaiKhoan ? parseInt(_ctx.taiKhoanData.maTaiKhoan) : undefined,
            "ma-chi-tiet-prop": _ctx.taiKhoanData.maChiTiet ? _ctx.taiKhoanData.maChiTiet : undefined,
            label: "Tài khoản",
            onOnSelect: _ctx.onSelectTaiKhoan
          }, null, 8, ["ma-tai-khoan-prop", "ma-chi-tiet-prop", "onOnSelect"]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "note",
                class: "form-control form-control-lg form-control-solid",
                placeholder: "Ghi chú",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.note) = $event))
              }, null, 512), [
                [_vModelText, _ctx.note]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "address",
                class: "form-control form-control-lg form-control-solid",
                placeholder: "Địa chỉ",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.address) = $event))
              }, null, 512), [
                [_vModelText, _ctx.address]
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.addressErrorMess), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("select", {
                class: "form-control form-control-lg",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.departmentId) = $event)),
                disabled: "",
                readonly: ""
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departments, (d, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: d.id
                  }, _toDisplayString(d.name), 9, _hoisted_23))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.departmentId]
              ])
            ])
          ])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_ButtonCustom, {
          "button-type": _ctx.ButtonsType.SAVE,
          onClick: _ctx.onSubmit
        }, null, 8, ["button-type", "onClick"])
      ])
    ]),
    _: 1
  }))
}